module.exports = __webpack_public_path__ + "img/logo.0bf553d.svg";